import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b61be2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error" }
const _hoisted_2 = { class: "error__404" }
const _hoisted_3 = { class: "error__404-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1))
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", {
            innerHTML: _ctx.t('404.description')
          }, null, 8, _hoisted_5),
          _createVNode(_component_router_link, {
            custom: "",
            to: "/"
          }, {
            default: _withCtx(({ navigate, href }) => [
              _createVNode(_component_Button, {
                href: href,
                onClick: navigate,
                innerHTML: _ctx.t('404.main')
              }, null, 8, ["href", "onClick", "innerHTML"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}